let header = 'fontSize:10pt;background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48); '
let loading;
export default {
  methods: {
    tdStyleFontSize() {
      return 'fontSize:9pt;'
    },
    //表头样式
    headerStyle() {
      return header + 'padding:1px;';
    },
    //表格样式
    tdStyleLeft() {
      return 'text-align:left;' + this.tdStyleFontSize();
    },
    tdStyleRight() {
      return 'text-align:right;' + this.tdStyleFontSize();
    },
    // Dialog 表格样式
    dialogHeaderStyle() {
      return header + 'padding:2px;';
    },
    dialogCellStyle_left() {
      return 'text-align:left;' + this.tdStyleFontSize();
    },
    dialogCellStyle_center() {
      return 'text-align:center;' + this.tdStyleFontSize();
    },
    set_loading() {
      //实现Loading 加载方法
      loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
    },
    close_loading() {
      //close Loading
      if ("undefined" != typeof loading) {
        loading.close();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/statics/css.js